export enum ModalActionsEnum {
  CREATE,
  UPDATE,
  DELETE,
}
